import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    functionCardContainer: css({
        width: 203,
        height: 186,
        background: Color.primary[400],
        borderRadius: 8,
        textAlign: 'center',
        boxSizing: 'border-box',
        cursor: 'pointer',
        "&:hover": {
            background: Color.primary[500],
        }
    }),
    functionIconContainer: css({
        "& svg": {
            marginTop: 35,
            width: 56,
            height: 56,
            color: Color.neutral[100]
        }
    }),
    functionIconTypography: css({
        marginTop: 24,
    })
});
